import React, { useContext } from 'react';
import { MenuBtn, ReponseMenu, StyledDiscoverTeamCard, StyleItem } from './DiscoverTeamCard.style';
import { TemporaryChatContext } from '../../../../Context/temporaryChatContext';
import { AuthContext } from '../../../../Context/authContext';
import { useContextHook } from 'use-context-hook';
import { useNavigate } from 'react-router-dom';
import sessionsService from '../../../../services/sessionsServices';
import cardIcon from '../../../../assets/feeda-icon.svg';
import { PiDotsThreeOutlineVertical } from 'react-icons/pi';

const DiscoverTeamCard = ({ teamCardsData, filterName }) => {
  const { setChatmessages, updateAgent, setSessionAgent } = useContext(TemporaryChatContext);
  const { user } = useContextHook(AuthContext, v => ({
    user: v.user,
  }));
  const navigate = useNavigate();
  const chatWithAgent = async agentObj => {
    updateAgent(agentObj);
    setSessionAgent(agentObj);
    setChatmessages([]);
    const sessionRes = await sessionsService.createSession({
      user_id: user?.data?.ID,
      platform_id: 'feedalabs',
      agent_id: agentObj?.value,
      project_id: 'test',
    });
    navigate(`/chat/${sessionRes?.session_id}`);
  };

  function getImageSrc(base64String, fallback) {
    if (!base64String) return fallback;
    if (base64String.startsWith('data:image')) {
      return base64String;
    }
    return fallback;
  }
  return (
    <>
      {teamCardsData
        ?.filter(card => {
          if (!filterName) return true;
          return card.team_name.toLowerCase().includes(filterName.toLowerCase());
        })
        ?.map(card => (
          <StyledDiscoverTeamCard key={card.id}>
            <div className="card-header">
              <div className="img-box">
                <img src={getImageSrc(card?.icon, cardIcon)} alt="img" />
              </div>
              <ReponseMenu
                menuButton={
                  <MenuBtn>
                    <PiDotsThreeOutlineVertical size="22" />
                  </MenuBtn>
                }>
                <StyleItem
                  onClick={() =>
                    chatWithAgent({
                      label: card?.team_name,
                      value: card?.team_id,
                      icon: card?.icon,
                      mode: 'team',
                    })
                  }>
                  <div className="text">Chat</div>
                </StyleItem>
              </ReponseMenu>
            </div>
            <div className="text-box">
              <strong className="title">{card.team_name}</strong>
              <p>{card.description}</p>
            </div>
          </StyledDiscoverTeamCard>
        ))}
    </>
  );
};

export default DiscoverTeamCard;
